import { render, staticRenderFns } from "./CreateDepartment.vue?vue&type=template&id=651e0c5c&"
import script from "./CreateDepartment.vue?vue&type=script&lang=ts&"
export * from "./CreateDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports